/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {RouterModule, Routes} from '@angular/router';
import {RolesManagementComponent} from './roles-management/roles-management.component';
import {RoutingMenuItemModel} from '../shared/utils/routing-menu-item.model';
import {NgModule} from '@angular/core';
import {Permission} from '../shared/utils/permission.enum';
import {PermissionsGuard} from '../permissions.guard';
import {
    BusinessSettingsMainPageComponent
} from './business-settings/business-settings-main-page/component/business-settings-main-page.component';
import {NeverActivateRouting} from '../never-activate-routing';
import {AlertsMainPageComponent} from './alerts/alerts-main-page/alerts-main-page.component';

export const routes: Routes = [
    {
        path: 'settings',
        canActivate: [PermissionsGuard],
        canActivateChild: [PermissionsGuard],
        data: {
            hasSideBarMenu: true,
            breadcrumb: 'Settings',
            permissions: [Permission.ADMIN_ROLE_VIEW, Permission.PARTNER_ROLE_VIEW, Permission, Permission.ADMIN_ALERTS_CONFIG_VIEW],
            menuItem: {
                label: 'Settings',
                icon: 'iwp-icon-gen_settings',
                index: 6
            } as RoutingMenuItemModel
        },
        children: [
            {
                path: 'membership',
                data: {
                    hasSideBarMenu: true,
                    breadcrumb: 'Membership',
                    permissions: [Permission.ADMIN_ROLE_VIEW, Permission.PARTNER_ROLE_VIEW],
                    menuItem: {
                        label: 'Membership',
                    } as RoutingMenuItemModel
                },
                children: [
                    {
                        path: '',
                        canActivate: [NeverActivateRouting],
                        redirectTo: '',
                        pathMatch: 'full'
                    },
                    {
                        path: 'partners',
                        component: RolesManagementComponent,
                        data: {
                            permissions: [Permission.ADMIN_ROLE_VIEW, Permission.PARTNER_ROLE_VIEW],
                            hasSideBarMenu: true,
                            breadcrumb: 'Partners',
                            context: 'PNW2',
                            menuItem: {
                                label: 'Partners',
                            } as RoutingMenuItemModel
                        }
                    },
                    {
                        path: 'ascc',
                        component: RolesManagementComponent,
                        data: {
                            permissions: [Permission.ADMIN_ROLE_VIEW],
                            hasSideBarMenu: true,
                            breadcrumb: 'ASCC',
                            context: 'ASCC',
                            menuItem: {
                                label: 'ASCC',
                            } as RoutingMenuItemModel
                        }
                    }
                ]
            },
            {
                path: 'backoffice',
                component: BusinessSettingsMainPageComponent,
                data: {
                    hasSideBarMenu: true,
                    breadcrumb: 'Backoffice',
                    permissions: [Permission.ADMIN_BUSINESS_SETTINGS_VIEW],
                    menuItem: {
                        label: 'Backoffice'
                    } as RoutingMenuItemModel
                }
            },
            {
                path: 'alerts',
                component: AlertsMainPageComponent,
                data: {
                    hasSideBarMenu: true,
                    breadcrumb: 'Alerts',
                    permissions: [Permission.ADMIN_ALERTS_CONFIG_VIEW],
                    menuItem: {
                        label: 'Alerts'
                    } as RoutingMenuItemModel
                }
            },
            {
                path: '',
                canActivate: [NeverActivateRouting],
                redirectTo: '',
                pathMatch: 'full'
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
    providers: [NeverActivateRouting]
})
export class SettingsRoutingModule {
}

